import { isTestEnvironment } from './environment';

export const isAuthenticated = (
  cookies: Record<string, string | undefined>
): boolean => (isTestEnvironment() ? 'yletestlogin' : 'ylelogin') in cookies;
